export default "__VITE_ASSET__DLPs9ecu__"